// Thin wrapper over AntD's `message` API so features don't have to import
// from antd directly for toasts. Use this for transient feedback only;
// for blocking confirmation use AntD's Modal.
import { App } from 'antd';
import { SESSION_EXPIRED_CODE, SESSION_EXPIRED_MESSAGE } from '@core/constants/auth';

export function useToast() {
  const { message } = App.useApp();

  return {
    success: (content, duration) => message.success(content, duration),
    error: (content, duration) => {
      if (content === SESSION_EXPIRED_MESSAGE) return undefined;
      return message.error(content, duration);
    },
    warning: (content, duration) => message.warning(content, duration),
    // `icon` swaps the default glyph, e.g. a neutral-coloured info icon where
    // the theme's info colour (the brand primary) would read as an error.
    info: (content, duration, { icon } = {}) =>
      icon
        ? message.open({ type: 'info', content, duration, icon })
        : message.info(content, duration),
    /**
     * Drop-in for catch blocks. Reads APIError.message; falls back to a default.
     * @param {unknown} err
     * @param {string} [fallback]
     */
    apiError: (err, fallback = 'Something went wrong.') => {
      if (err?.code === SESSION_EXPIRED_CODE) return;
      const text = err && typeof err === 'object' && 'message' in err ? err.message : fallback;
      message.error(text || fallback);
    },
  };
}
